module.exports = __webpack_public_path__ + "img/github.6c8cb60a.svg";